// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"6c9fe2cc","748":"25caacd0"}[chunkId] + ".chunk.js";
};